module.exports = __webpack_public_path__ + "static/profil-588_optimized-7efe8637bc1bb80a02f791360bd28d90.jpg";